import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

import emptySrc from 'images/point_empty.png'

export function PointRecordEmpty() {
  const history = useHistory()

  return (
    <EmptyContainer>
      <EmptyImage src={emptySrc} />
      <EmptyDesc>
        포인트 내역이 없어요
        <br />
        챌린지 인증하고 포인트 받아보세요!
      </EmptyDesc>
      <EmptyButton onClick={() => history.replace('/')}>포인트 받으러 가기</EmptyButton>
    </EmptyContainer>
  )
}

const EmptyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: calc(100vw * (44 / 375));
`

const EmptyImage = styled.img`
  width: calc(100vw * (71 / 375));
  height: calc(100vw * (71 / 375));
  margin-top: calc(100vw * (49 / 375));
`

const EmptyDesc = styled.div`
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (21 / 375));
  text-align: center;
  color: #7f7f7f;
  margin-top: calc(100vw * (16 / 375));
`

const EmptyButton = styled.button`
  width: calc(100vw * (148 / 375));
  height: calc(100vw * (49 / 375));
  margin-top: calc(100vw * (23 / 375));
  border: 1px solid #4e4e4e;
  border-radius: calc(100vw * (10 / 375));
  font-weight: 600;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (23 / 375));
  text-align: center;
  color: #4e4e4e;
`
